angular.
module("dx.webapp.grade").
controller("DxGradingTypeController", function GradingTypeController(
	$scope,

	DX_QUESTION_GRADING_TYPE,
	dxLocalize
) {
	"use strict";
	var self = this;
	self.gradingTypeText = "";
	self.tooltipText = "";

	$scope.$watch("vm.gradingType", function updateText() {
		switch (self.gradingType) {
			case DX_QUESTION_GRADING_TYPE.ALL_OR_NOTHING:
				setGradingAndTooltipText(dxLocalize.get("GradingOptions.AllOrNothing"), dxLocalize.get("GradingOptions.AllOrNothing.Tooltip"));
				break;
			case DX_QUESTION_GRADING_TYPE.RIGHT_MINUS_WRONG:
				setGradingAndTooltipText(dxLocalize.get("GradingOptions.RightMinusWrong"), dxLocalize.get("GradingOptions.RightMinusWrong.Tooltip"));
				break;
			case DX_QUESTION_GRADING_TYPE.POINTS_PER_RESPONSE:
				setGradingAndTooltipText(dxLocalize.get("GradingOptions.PointsPerResponse"), dxLocalize.get("GradingOptions.PointsPerResponse.Tooltip"));
				break;
			default:
				break;
		}
	});

	function setGradingAndTooltipText(gradingText, tooltipText) {
		self.gradingTypeText = gradingText;
		self.tooltipText = tooltipText;
	}
});
